import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

/**
 * Wraps a React Query call against an endpoint that returns
 * `{ items, pagination }`. Keeps `page` and arbitrary filters in
 * component state and exposes setters that reset the page when a
 * filter changes.
 */
export function usePaginatedQuery({ key, fetcher, initialFilters = {}, initialLimit = 20 }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(initialLimit);
  const [filters, setFilters] = useState(initialFilters);

  const params = { page, limit, ...filters };
  const query = useQuery({
    queryKey: [...key, params],
    queryFn: () => fetcher(params)
  });

  const updateFilter = (patch) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, ...patch }));
  };

  return {
    page,
    setPage,
    limit,
    setLimit,
    filters,
    setFilters: updateFilter,
    items: (query.data && query.data.items) || [],
    pagination: query.data && query.data.pagination,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch
  };
}
